module.exports = new __parcel__URL__("id-badge.7070a4f3.svg").toString();